import { render } from "./ScrollPanaromaMousewheel.vue?vue&type=template&id=6215075a&scoped=true"
import script from "./ScrollPanaromaMousewheel.vue?vue&type=script&lang=js"
export * from "./ScrollPanaromaMousewheel.vue?vue&type=script&lang=js"

import "./ScrollPanaromaMousewheel.vue?vue&type=style&index=0&id=6215075a&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6215075a"]])

export default __exports__